<template>
    <div class="Technicians">
        <div class="techList" v-if="techData.length > 0">
            <div class="techItem" v-for="item in techData" :key="item.id">
                <div class="techPhoto">
                    <img v-if="item.image && item.image.file_path" :src="getUrl(item.image.file_path)" :alt="item.name" />
                    <div v-else class="photoEmpty">{{ (item.name || '?').charAt(0).toUpperCase() }}</div>
                </div>
                <div class="techInfo">
                    <div class="techName">{{ item.name }}</div>
                    <div class="techExp" v-if="item.experience_years > 0">{{ item.experience_years }} Years Exp.</div>
                    <div class="techRow" v-if="item.service_style">
                        <span class="rowLabel">Style:</span>{{ item.service_style }}
                    </div>
                    <div class="techRow" v-if="item.good_at">
                        <span class="rowLabel">Good at:</span>{{ item.good_at }}
                    </div>
                    <div class="techIntro" v-if="item.intro">{{ item.intro }}</div>
                </div>
            </div>
        </div>
        <van-empty v-if="techData.length === 0 && !loading" description="No technicians" />
        <van-loading v-if="loading" type="spinner" size="24px" vertical>Loading...</van-loading>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin'
export default {
    name:'Technicians',
    mixins: [myMixin],
    props:{
        shop_supplier_id:{
            type: [String, Number],
            default:''
        }
    },
    data(){
        return {
            techData:[],
            loading: false
        }
    },
    created(){
        this.getSupplierTechnician()
    },
    methods:{
        getSupplierTechnician(){
            this.loading = true
            this.$api.getSupplierTechnician({ shop_supplier_id: this.shop_supplier_id }).then(res=>{
                if(res.code == 1 && res.data && res.data.list){
                    this.techData = res.data.list || []
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .Technicians{
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        .techList{
            padding-top: 1rem;
        }
        .techItem{
            display: flex;
            gap: .75rem;
            padding: .875rem;
            margin-bottom: .75rem;
            background: #F0F7F6;
            border-radius: .5rem;
            .techPhoto{
                flex: 0 0 auto;
                width: 4.5rem;
                height: 4.5rem;
                border-radius: .5rem;
                overflow: hidden;
                background: #D2D8D8;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }
                .photoEmpty{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 1.75rem;
                    font-weight: 600;
                    background: #1E3C3E;
                }
            }
            .techInfo{
                flex: 1;
                min-width: 0;
                .techName{
                    font-size: 1rem;
                    font-weight: 600;
                    color: #1A3232;
                }
                .techExp{
                    display: inline-block;
                    margin-top: .25rem;
                    padding: .0625rem .375rem;
                    font-size: .6875rem;
                    color: #1E3C3E;
                    background: #DCEDE9;
                    border-radius: .25rem;
                }
                .techRow{
                    font-size: .8125rem;
                    color: #555;
                    line-height: 1.5;
                    margin-top: .25rem;
                    word-break: break-word;
                    .rowLabel{
                        color: #999;
                        margin-right: .25rem;
                    }
                }
                .techIntro{
                    font-size: .8125rem;
                    color: #333;
                    line-height: 1.5;
                    margin-top: .375rem;
                    word-break: break-word;
                }
            }
        }
    }
</style>
